import Vue from 'vue'
import { Message } from './types'
import { AiConfig, ProviderId, loadConfig, saveConfig } from './keyStore'

// Reactive, app-wide conversation state. It lives in module scope (not in a
// component) so the conversation survives navigation and tab switches — the
// chat panel is just a view over this store, and the agent loop mutates it
// directly for live streaming.

export type AiStore = {
	messages: Message[],
	running: boolean,
	error: string | null,
	activeSkillId: string | null,
	config: AiConfig,
}

export const store: AiStore = Vue.observable({
	messages: [],
	running: false,
	error: null,
	activeSkillId: null,
	config: loadConfig(),
})

// The abort controller is intentionally kept out of the reactive store.
export let abortController: AbortController | null = null
export function setAbortController(c: AbortController | null) { abortController = c }

export function currentApiKey(): string | undefined {
	return store.config.apiKeys[store.config.provider]
}

export function hasKey(): boolean {
	return !!currentApiKey()
}

export function updateConfig(patch: Partial<AiConfig>) {
	store.config = { ...store.config, ...patch }
	saveConfig(store.config)
}

export function setApiKey(provider: ProviderId, key: string) {
	updateConfig({ apiKeys: { ...store.config.apiKeys, [provider]: key } })
}

export function clearConversation() {
	store.messages = []
	store.error = null
}
